export const isImage = (file) => file && file['type'].split('/')[0] === 'image'
